import * as stylex from "@stylexjs/stylex";
import { Image, Upload } from "lucide-react";
import { copy } from "@/copy";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Button } from "@/ui/Button";
import { ColorBlock } from "@/ui/ColorBlock";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
import { OfflinePill } from "@/ui/OfflinePill";
import { AddFromPhoneCard, type QrShown } from "./AddFromPhone";
type PhotosEmptyProps = {
  online: boolean;
  qr?: QrShown;
  onUpload: () => void;
  onChooseFiles: () => void;
};
const styles = {
  block: {
    kzQI83: "x1iyjqo2",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    k9WMMc: "x2b8uid",
    kOIVth: "x1rzw5jd",
    $$css: true
  }
};
export function PhotosEmpty({
  online,
  qr,
  onUpload,
  onChooseFiles
}: PhotosEmptyProps) {
  return <div className="x1us19tq x78zum5 xdt5ytf">
      <ColorBlock tone="soft" padding="clamp(28px, 3.2vw, 48px)" xstyle={styles.block}>
        <Icon icon={Image} size={56} strokeWidth={1.25} />
        <div className="x78zum5 xdt5ytf x6s0dn4 x1v2ro7d">
          <Eyebrow>{copy.photos.count(0)}</Eyebrow>
          <h2 className="x1ghz6dp x4c74qz x1v94iar x75m3dq x1f41ap9">{copy.photos.emptyTitle}</h2>
          <span className="xosj86m x15i68ds xfrs9s4 x1lwm3bp x1fzhlzt">{copy.photos.emptyBody}</span>
        </div>
        {qr ? <AddFromPhoneCard qr={qr} onChooseFiles={onChooseFiles} /> : <Button icon={Upload} disabled={!online} onClick={onUpload}>
            {copy.photos.uploadPhotos}
          </Button>}
        {!online && <OfflinePill label={copy.photos.row.offline} />}
      </ColorBlock>
    </div>;
}